function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont18 = function SvgFont18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.773,
    height: 12.602
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25807",
    d: "M1.172-.591a2.544 2.544 0 0 1 .4-1.4 2.512 2.512 0 0 1 1.107-.946 16.938 16.938 0 0 0-2.217-.386 4.756 4.756 0 0 1 .731-2.548 4.735 4.735 0 0 1 1.978-1.72 6.594 6.594 0 0 1 2.9-.613 6.2 6.2 0 0 1 2.7.559 4.312 4.312 0 0 1 1.817 1.559 4.17 4.17 0 0 1 .645 2.312V4.4h-2.75v-7.873a2.517 2.517 0 0 0-.72-1.86 2.573 2.573 0 0 0-1.9-.72 3.755 3.755 0 0 0-1.8.43 2.241 2.241 0 0 0-1.085 1.118 11.34 11.34 0 0 1 1.387.387 5.185 5.185 0 0 1 1.108.518v.774a2.441 2.441 0 0 0-1.15.817 2.109 2.109 0 0 0-.4 1.29V4.4H1.172z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont18;